import moment from 'moment';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en';
Vue.use(VueI18n);
const messages = { en };
const locale = 'en';
const i18n = new VueI18n({
    locale,
    messages,
});
// Set moment's locale
moment.locale(window.navigator.language);
export default i18n;
